var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordhomw-wrap"},[_c('div',{staticClass:"v-note-wrapper markdown-body shadow"},[_c('h3',[_c('a',{attrs:{"id":"_0"}}),_vm._v("内容国际化")]),_c('p',[_vm._v("页面内容国际化，使用$t2调用。")]),_c('p',[_vm._v("例如:")]),_c('pre',[_c('code',{staticClass:"lang-language"},[_vm._v("$t2(\"t_login\")\r\n")])])])])
}]

export { render, staticRenderFns }